import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuComponent } from '../menu/menu.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [CommonModule, RouterLink, MenuComponent, FormsModule]
})
export class SidebarComponent {
  options = {
    lang: 'en',
    theme: 'winter',
    settings: false,
    docked: false,
    boxed: false,
    opened: false
  };

  @Output()
  messageEvent = new EventEmitter<Object>();
  @Output()
  toggleFullscreen = new EventEmitter<void>();
  @Output()
  menuClick = new EventEmitter<void>();

  constructor(public translate: TranslateService) {
    const browserLang: string | any = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }

  sendMessage() {
    this.messageEvent.emit(this.options);
  }

  setTheme(theme : any) {
    this.options.theme = theme;
    this.sendMessage();
  }
  
  /**
   * Handle menu item click event
   * Emit to parent component to close sidebar on mobile
   */
  onMenuItemClicked(): void {
    this.menuClick.emit();
  }
}
